module.exports = __webpack_public_path__ + "static/img/9.25e9da1f.png";